/* @flow */
import cx from 'classnames';
import * as React from 'react';
import shallowCompare from 'react-addons-shallow-compare';

import Textarea from 'components/Textarea.jsx';

import './styles/Composer.scss';

type Props = {
  error: boolean,
  autoFocus?: ?boolean,
  onChange: Function,
  onFocus?: ?Function,
  onBlur?: ?Function,
  onReturnKeyPress?: (e: SyntheticKeyboardEvent<>) => boolean,
  placeholder?: ?string,
  value: ?string,
  className: ?string,
  indicator?: any,
  children?: React.Node,
  rows?: number,
  autogrow?: boolean,
  constrainMaxHeight?: boolean,
};

class Composer extends React.Component<Props, *> {
  static defaultProps = {
    rows: 1,
  };

  state = {
    focused: false,
  };

  shouldComponentUpdate(nextProps: Object, nextState: Object) {
    return shallowCompare(this, nextProps, nextState);
  }

  focus = () => {
    this.refs.textarea.focus();
  };

  clear = () => {
    this.refs.textarea.clear();
  };

  handleTextareaBlur = () => {
    this.setState({ focused: false });
    if (this.props.onBlur) {
      this.props.onBlur();
    }
  };

  handleTextareaFocus = () => {
    this.setState({ focused: true });
    if (this.props.onFocus) {
      this.props.onFocus();
    }
  };

  render() {
    const {
      children,
      error,
      className,
      onChange,
      placeholder,
      indicator,
      onReturnKeyPress,
      rows,
      value,
      constrainMaxHeight,
      autogrow,
      autoFocus,
    } = this.props;

    const composerHasChildren =
      children && React.Children.toArray(children).filter(child => !!child).length;

    return (
      <div
        className={cx(
          'Composer',
          {
            'Composer-focus': this.state.focused,
            'Composer-error': error,
          },
          className
        )}>
        <div className="Composer-input">
          <Textarea
            autoFocus={autoFocus}
            autogrow={autogrow}
            rows={rows}
            ref="textarea"
            data-test-selector="chat-composer"
            className={cx('Composer-input-textarea', {
              'Composer-input-textarea-constrain': constrainMaxHeight,
            })}
            onFocus={this.handleTextareaFocus}
            onBlur={this.handleTextareaBlur}
            onReturnKeyPress={onReturnKeyPress}
            onChange={onChange}
            value={value}
            placeholder={placeholder}
          />
          {indicator ? <div className="Composer-input-indicator">{indicator}</div> : null}
        </div>
        {composerHasChildren ? <div className="Composer-content">{children}</div> : null}
      </div>
    );
  }
}

export default Composer;
